// extracted by mini-css-extract-plugin
export default {"addToCartControl":"N1-z","giftCard":"O1-z","btnContainer":"P1-z","cartButton":"Q1-z","disabled":"R1-z"};